<template>
<div style="height: 100%">
    <div id="evolve">Evolve</div>
    <div class="row" id="content">
        <div class="col d-flex flex-row align-items-center">
            <div id="form">
                <form @submit.prevent="login">
                    <div class="row">
                        <h1 id="title">Log In</h1>
                    </div>
                    <p v-if="feedback" class="feedback">{{feedback}}</p>
                    <div class="form-group">
                        <input name="email" id="email" placeholder="EMAIL" v-model="email" class="form-control">         
                    </div>
                    <div class="form-group">
                        <input type="password" name="password" id="password" placeholder="PASSWORD" v-model="password" class="form-control"/>
                    </div>
                    <div class="d-flex flex-column" >
                    <div> 
                        
                        <button type="submit" class="btn btn-primary" v-if="!loading">LOG IN</button>
                    </div>
                    <div class="row bottomline">
                        <p><a @click.prevent="forgotpassword" class="forgot">Forgot password?</a>  Don't have an account? 
                        <router-link :to="{name: 'SignUp'}"><span id="signup">Sign up</span></router-link>
                        </p>
                    </div>
                    </div>
                    <div v-if="loading">
                        <p>Loading...</p>
                    </div>
                </form> 
            </div>
        </div>
        <!-- <div class="col d-flex flex-row justify-content-center align-items-center">
            <div id="writing">
                <div class="upperwriting d-flex flex-column align-items-end">
                    <p>5K+ WALLETS</p>
                </div>
                <div class="bottomwriting d-flex flex-column align-items-end">
                    <p>300K+ TRANSACTIONS</p>
                </div>
            </div>
        </div> -->
    </div>
</div>
</template>
<script>
import firebase from '@/firebase/init'
export default {
    name: 'Login',
    data(){
        return{
            email: null,
            password: null,
            loading: false,
            feedback: null
        }
    },
    methods:{
        login(){
            if(this.email && this.password){
                var parentobj = this
                this.loading = true
                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(cur=>{
                    var db = firebase.firestore()
                    let ref = db.collection('users').where('UID', '==', cur.user.uid)
                    ref.get().then(snapshot=>{
                        snapshot.forEach(doc=>{
                            var data = doc.data()
                            if(data.OnBoardingCompleted === true){
                                this.$router.push({name: 'Home'})
                            }
                            else{
                                this.$router.push({name: 'Step1', params: {uid: cur.user.uid, previousname: cur.user.displayName, previousemail: cur.user.email, previousrole: null, previousspiritanimal: null, previousicon: null, previouscompanyName: null,
                                previousbriefdescription: null, previouslogo: null, previousdescription: null}} )
                            }
                        })
                    })
                    
                })
                .catch(err=>{
                    if(err.code == "auth/user-not-found"){
                        this.feedback = "There was  no user found with these credentials."
                    }
                    else{
                        this.feedback = err.message
                    }
                    this.loading = false
                })
                this.feedback = null
            }
            else{
                this.feedback = "You must enter all fields";
            }
            
        },
        forgotpassword(){
           this.$router.push({name: 'ForgotPassword'})
        }
    },
    beforeCreate: function() {
            document.body.className = 'signup'
            this.$parent.showNavbar = false        
    }
}
</script>
<style scoped>
.forgot{
    cursor: pointer;
}
.feedback{
    color: red;
}
#evolve{
    font-family: GothamRndSSm-Light;
    font-size: 22px;
    color: black;
    margin: 0 0 0 5em;
    height: 5%;
    text-align: start;
    bottom: 0;
    text-anchor: end;
    margin-top: 3em;
}
.form-control{
    border-color: black;
    height: 3.5em;
    margin-top: 1.5em;
    padding-left: 1.5em;
    border-radius: 0.5em;
    line-height: normal;
    line-height: 32px;
}
.btn{
    font-size: 0.7em !important;
    height: 5em;
    width: 50%;
    right: 0;
    margin-top: 1.5em;
    float: left;
    background-color: #5D38DB;
    border-radius: 0.5em;
    line-height: inherit;
}
::placeholder {
  color: black !important;
  font-family: GothamRndSSm-Book;
  font-size: 10px !important;

}
#form{
    width: 30em;
    margin-left: 10em;
}
#title{
    color: black;
    font-size: 40px;
    font-family: GothamRndSSm-Light;
}
p{
    margin-top: 1.5em;
    margin-bottom: 3em;
}
.row h1{
    margin-left: 0.5em;
    margin-bottom: 0.8em;
}
.bottomline p{
    margin-left: 1em;
    font-weight: 500;
    font-size: 12px;
    margin-top: 1.5em;
    margin-bottom: 3em;
    color: black;
    font-family: GothamRndSSm-Book;
}
#signup{
    color: black;
    font-family: GothamRndSSm-Book;
    font-size: 12px;
    cursor: pointer;
    font-weight: 500;
}
#writing{
    margin-bottom: 5em;

}
.upperwriting p{
    color: black;
    font-size: 42px !important;
    font-family: GothamRndSSm-Light;
    margin: 0;
    float: right;
    letter-spacing: 2px;
}
.bottomwriting p{
    font-size: 22px !important;
    margin: 0;
    margin-left: auto;
    color: black;
    font-family: GothamRndSSm-Book;
    letter-spacing: 1px;
}
#content{
    height: 90%;
    margin-left: 0;
    margin-right: 0;
}
@media (max-width: 700px) {
    #evolve{
        margin-left: 3em;
    }
    #form{
        margin-left: 2em;
    }
}
@media (max-width: 600px) {
    #evolve{
        padding-top: 0;
        margin-top: 2em;
        margin-left: 1em;
    }
    #form{
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue